(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["gallery-progress-ttt"] && !Shopify.designMode) return;
  try {
    class GalleryProgressTtt extends HTMLElement {
    /** @type {HTMLElement | null} */
    #scroller = null;

    /** @type {ResizeObserver | undefined} */
    #resizeObserver;

    connectedCallback() {
      const section = this.closest('.shopify-section');
      this.#scroller = section?.querySelector('.product-information__media slideshow-slides') ?? null;

      if (!this.#scroller) {
        this.hidden = true;
        return;
      }

      this.#scroller.addEventListener('scroll', this.#update, { passive: true });
      this.#resizeObserver = new ResizeObserver(this.#update);
      this.#resizeObserver.observe(this.#scroller);
      this.#update();
    }

    disconnectedCallback() {
      this.#scroller?.removeEventListener('scroll', this.#update);
      this.#resizeObserver?.disconnect();
    }

    #update = () => {
      const scroller = this.#scroller;
      if (!scroller) return;

      const { scrollWidth, clientWidth } = scroller;
      const maxScroll = scrollWidth - clientWidth;

      if (maxScroll <= 1) {
        this.style.visibility = 'hidden';
        return;
      }

      this.style.visibility = '';

      const visibleRatio = clientWidth / scrollWidth;
      const scrolled = Math.min(Math.abs(scroller.scrollLeft) / maxScroll, 1);

      this.style.setProperty('--gp-thumb-size', `${visibleRatio * 100}%`);
      this.style.setProperty('--gp-thumb-offset', `${scrolled * (1 - visibleRatio) * 100}%`);
    };
  }

  if (!customElements.get('gallery-progress-ttt')) {
    customElements.define('gallery-progress-ttt', GalleryProgressTtt);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["share-ttt"] && !Shopify.designMode) return;
  try {
    class ShareTtt extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.#handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.#handleClick);
    }

    /** @param {MouseEvent} event */
    #handleClick = async (event) => {
      const button = /** @type {HTMLElement | null} */ (
        event.target instanceof Element ? event.target.closest('[data-share-url]') : null
      );
      if (!button) return;

      const url = button.dataset.shareUrl ?? window.location.href;
      const status = this.querySelector('.share-ttt__status');

      try {
        await navigator.clipboard.writeText(url);
        button.classList.add('share-ttt__link--copied');
        if (status instanceof HTMLElement) status.textContent = status.dataset.copiedText ?? '';
        setTimeout(() => button.classList.remove('share-ttt__link--copied'), 2000);
      } catch {
        window.prompt('', url);
      }
    };
  }

  if (!customElements.get('share-ttt')) {
    customElements.define('share-ttt', ShareTtt);
  }
  } catch(e) { console.error(e); }
})();

})();
